import classNames from 'classnames'
import { Link } from 'react-router-dom'

export interface MenuItemProps {
    icon: React.ReactNode
    title: string
    description: string | React.ReactNode
    active?: boolean
    href?: string
    className?: string
}
export function MenuItem({
    icon,
    title,
    description,
    active = false,
    href,
    className,
}: MenuItemProps) {
    const wrapperClasses = classNames(
        'group',
        'bg-white rounded-sm',
        'border border-gray-900 box-border',
        'shadow-md',
        'transition-opacity',
        'hover:opacity-100',
        'flex flex row p-4 items-center rounded',
        'max-w-96',
        'opacity-40',
        'h-full',
        'w-full',
        'col-span-2',
        { 'opacity-100': active },
        className,
    )

    const titleStyles = classNames(
        'not-italic',
        'font-bold',
        'text-sm leading-2 flex items-center',
    )

    const descriptionStyles = classNames(
        'not-italic',
        'text-sm leading-2 flex items-center',
    )
    const Item = () => (
        <div className={wrapperClasses}>
            {icon}
            <div className='ml-4'>
                <div className={titleStyles}>{title}</div>
                <div className={descriptionStyles}>{description}</div>
            </div>
        </div>
    )
    return href ? (
        <Link to={href} className='w-full'>
            <Item />
        </Link>
    ) : (
        <Item />
    )
}
